<ngx-loading [show]="isProcessing"></ngx-loading>

<section>
  <datalist id="listCentroCustos">
    <select>
      <option *ngFor="let item of centrosDeCusto" [value]="item.nome"></option>
    </select>
  </datalist>
</section>


<div class="row">
  <div class="col">

    <div class="box box-primary box-dark">

      <div class="box-header text-center">
        <h3 class="box-title  text-dark">Acompanhar PT</h3><br />
      </div>
      <div class="divider"></div>
      <div class="box-body">

        <form novalidate [formGroup]="form" (ngSubmit)="submit(false)">

          <div class="form-row">

            <div class="col-md-3" [hidden]="!this.autorizacaoPTOutrosUsuarios">
              <div class="position-relative form-group">
                <label for="id">Usuário solicitante</label>
                <select class="form-control" id="usId" formControlName="usuarioSolicitouId">
                  <option value="0" selected>Todos</option>
                  <option *ngFor="let u of usuarios" value="{{ u.id }}">{{ u.nome }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label for="">Tipo de data</label>
                <select class="form-control" formControlName="tipoData">
                  <option value="DataHoraUltimoStatus" selected>Data do Status</option>
                  <option value="DataHoraCadastro">Data da emissão</option>
                </select>
              </div>
            </div>

            <div class="col-md-3">
              <div class="form-group">
                <label for="id">Período Inicial</label>
                <input class="form-control" type="date" formControlName="dataInicial" id="dataInicial" max="2999-12-31">
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.hasError('dtInicioMuitoAntiga')">Data muito antiga</small>
                </section>
              </div>
            </div>

            <div class="col-md-3">
              <div class="position-relative form-group">
                <label for="requisitante">Período Final</label>
                <input class="form-control" type="date" formControlName="dataFinal" max="2999-12-31">
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.hasError('dtFinalMenorDtInicial')">Data Final deve ser maior que Data
                    Inicial</small>
                  <small *ngIf="form.hasError('dtFinalMuitoAntiga')">Data muito antiga</small>
                </section>
              </div>
            </div>




          </div>

          <div class="form-row">

            <div class="col-md-4">
              <div class="form-group">
                <label for="">Status PT</label>
                <select formControlName="status" class="form-control"
                  (change)="changeStatus($event.target.selectedOptions[0].text)">
                  <option value="">Todos</option>
                  <option value="4">OS Emitida</option>
                  <option value="5">Concluído</option>
                  <option value="6">Em Pendência</option>
                  <option value="7">OS Reprovada</option>
                </select>

              </div>
            </div>


            <div class="col-md-4">
              <div class="form-group">
                <label for="centroDeCusto">{{labelCentroCusto}}</label>
                <div class="input-group">
                  <input type="text" class="form-control" list="listCentroCustos" formControlName="centroCustoDescricao"
                    (change)="changeDataListCentroCustos($event.target.value)" maxlength="40" />
                  <div class="input-group-append cp" (click)="limparDataListCentroCustos()"
                    title="limpar campo e recarregar lista de opções">
                    <span class="input-group-text"><i class="fa fa-trash"></i></span>
                  </div>
                </div>
              </div>
            </div>



            <div class="col-md-2">
              <!--[disabled]="!this.autorizacao?.podeListar"-->
              <button type="submit" class="btn btn-primary btn-block btn-bottom btn-shadow dark"
                [disabled]="!this.form.valid || this.isProcessing"><i class="fa fa-search"></i></button>
            </div>

          </div>

        </form>

        <div class="divider"></div>

        <div class="box-table h450">

          <table>
            <thead>
              <tr>
                <th>Nº PT</th>
                <th>Serviço Solicitado</th>
                <th>Status PT</th>
                <th>Status OS</th>
                <th>Dt Hr Status</th>

              </tr>
            </thead>
            <tbody>
              <!-- (click)="getPTSelecionada(pt?.ptId, modal)" -->
              <tr *ngFor="let pt of this.pts">
                <td class="text-center">{{ pt?.ptId | zerosEsquerda : 5}}</td>
                <td class="mw280">{{ pt?.servico }}</td>
                <!-- <td class="text-center"><span class="badge badge-pill fw" [ngStyle]="{'background-color' : bgStatus[pt?.status]}">{{ pt?.statusStr }}</span></td> -->

                <td *ngIf="pt?.osId == null" class="text-center">
                  <span class="badge badge-pill fw" [ngStyle]="{'background-color' : bgStatus[pt?.status]}">{{
                    pt?.statusStr }}
                  </span>
                </td>

                <td *ngIf="pt?.osId != null" class="text-center cp"
                  title="clique aqui para visualizar detalhes da OS {{pt?.osId}}" (click)="showOS(pt?.osId, pt?.spvId)">
                  <span class="badge badge-pill fw" [ngStyle]="{'background-color' : bgStatus[pt?.status]}">{{
                    pt?.statusStr }}
                    <span> - Nº {{pt?.osId}} </span>
                  </span>
                </td>

                <td class="text-center">
                  <span *ngIf="pt?.statusOS != null" class="badge badge-pill fw"
                    [ngStyle]="{'background-color' : bgStatusOS[pt?.statusOS]}">
                    {{pt?.statusOSStr}}
                  </span>
                </td>


                <td class="text-center">{{ pt?.dataHoraUltimoStatus | date:'dd/MM/yyyy HH:mm' }}</td>
              </tr>
              <tr *ngFor="let v of this.voids">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <ng-template #nenhumresultado>
        </ng-template>

      </div>

      <div class="box-footer">
        <span *ngIf="this.pts !== undefined && this.pts?.length > 0" class="pl-2 pt-1 pb-2">Total PTs: <b>{{
            this.pts?.length }}</b></span>
      </div>


    </div>
  </div>
</div>

<div class="row">
  <div class="col">
    <div class="box box-primary box-dark">
      <div class="box-body">
        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-2">
            <div class="d-flex justify-content-end">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq-dark.png" /></a>
            </div>
          </div>
          <div class="col-md-6">
            <div class="d-flex justify-content-end">
              <app-ball-pulse *ngIf="isPesquisando"></app-ball-pulse>
              <button class="mr-2 btn btn-outline-primary btn-shadow dark-outline" (click)="reset()" type="button"><i
                  class="mr-2 fa fa-trash"></i>Limpar<span class="mr-2"></span></button>
              <button type="button" class="btn btn-primary btn-shadow dark"
                [disabled]="!this.form.valid || !this.autorizacoes.podeListar || this.pts?.length == 0"
                (click)="imprimir()"><i class="fa fa-print"></i><span class="pl-3 pr-3">Imprimir</span></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-detalhes-os [parameters]="this.parameters"></app-detalhes-os>